import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast, Spinner, Center } from '@chakra-ui/react';
import { useAuth } from '../context/AuthContext';
import { UpstoxAuthService } from '../services/upstoxAuth';
import { upstoxConfig } from '../config/upstox';

export const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();
  const { setUpstoxToken } = useAuth();
  const upstoxAuth = new UpstoxAuthService(upstoxConfig);

  useEffect(() => {
    const code = searchParams.get('code');
    console.log('Received code:', code); // Debug log
    
    if (!code) {
      toast({
        title: 'Error',
        description: 'No authorization code received',
        status: 'error',
        duration: 3000,
      });
      navigate('/dashboard');
      return;
    }

    const getToken = async () => {
      try {
        const response = await upstoxAuth.getAccessToken(code);
        setUpstoxToken(response.access_token);
        toast({
          title: 'Success',
          description: 'Successfully connected to Upstox',
          status: 'success',
          duration: 3000,
        });
      } catch (error: any) {
        toast({
          title: 'Error',
          description: error.message,
          status: 'error',
          duration: 3000,
        });
      } finally {
        navigate('/dashboard');
      }
    };

    getToken();
  }, [searchParams, navigate, setUpstoxToken, toast]);

  return (
    <Center h="100vh">
      <Spinner size="xl" />
    </Center>
  );
};
